import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function DocumentTypeList() {
  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="DocumentType"
      toggleStatusRoute="DocumentType"
      requestName="DocumentType"
      route="/TipoDocumento"
      cdPage="id"
      btnNew={true}
    />
  );
}
